module.exports = __webpack_public_path__ + "img/index-coop3.7cd3e47d.png";